import React, {Component} from 'react';
import MasonryGrid from './MasonryGrid.js';
import GridTile from './GridTile.js';

let peopleScrollTop = 0;
let productScrollTop = 0;
let personalScrollTop = 0;

export default class PhotoGrid extends Component {
  constructor(props) {
    super(props);

    this.getPeopleThumbs = this.getPeopleThumbs.bind(this);
    this.getPersonalThumbs = this.getPersonalThumbs.bind(this);
    this.getProductThumbs = this.getProductThumbs.bind(this);

    this.images = this.getImageType(props.imageType);
  }

  componentDidMount() {
    this.props.toggleWork(true);
    this.refs.masonry.scrollTop = this.getScroll(this.props.imageType);
  }

  componentWillUnmount() {
    switch(this.props.imageType) {
      case '/work/people':
        peopleScrollTop = this.refs.masonry ? Math.floor(this.refs.masonry.scrollTop) : 0;
        break;
      case '/work/products':
        productScrollTop = this.refs.masonry ? Math.floor(this.refs.masonry.scrollTop) : 0;
        break;
      case '/work/personal':
        personalScrollTop = this.refs.masonry ? Math.floor(this.refs.masonry.scrollTop) : 0;
        break;
    }
  }

  getScroll(type) {
    switch(type) {
      case '/work/people':
        return peopleScrollTop;
      case '/work/products':
        return productScrollTop;
      case '/work/personal':
        return personalScrollTop;
      default:
        return 0;
    }
  }

  getImageType(type) {
    switch (type) {
      case '/work/people':
        return this.getPeopleThumbs();
      case '/work/products':
        return this.getProductThumbs();
      case '/work/personal':
        return this.getPersonalThumbs();
      default:
        console.log('getting images didn\'t work');
        return null;
    }
  }

  getPeopleThumbs() {
    const imageObject = this.importImages(require.context('../images/people/thumbs', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  getPersonalThumbs() {
    const imageObject = this.importImages(require.context('../images/personal/thumbs', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  getProductThumbs() {
    const imageObject = this.importImages(require.context('../images/products/thumbs', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  importImages(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  render() {
    if (!this.images) {
      return <div>Error getting images</div>
    }

    return (
      <div className='masonry-container' id='scroll' ref='masonry'>
				<MasonryGrid type={this.props.imageType}>
					{this.images.map((image, i) => {
						return (
							<GridTile
                key={image}
                src={image}
                num={i+1}
                section={this.props.imageType}
              />
						)
					})}
				</MasonryGrid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PhotoGrid.js